import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import { connect } from "react-redux";
import DatePicker from "./DatePicker";
import MuiPhoneNumber from "material-ui-phone-number";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CheckBoxIcon from "@material-ui/icons/CheckBoxOutlined";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import { parsePhoneNumberFromString } from "libphonenumber-js";

class UserForm extends Component {
  state = {
    civilIDFocused: false,
  };

  getIsoFromPhone = (phone) => {
    const p = parsePhoneNumberFromString(phone || "");
    return p?.country ? p.country.toLowerCase() : null;
  };

  clearPhoneNumber = () => {
    const { language, setPhone, setPhoneError, setPhoneErrorText } = this.props;
    setPhone("");
    setPhoneError(true);
    let text =
      language === "english"
        ? "Phone number must match the selected country"
        : "رقم الهاتف لا يتطابق مع مفتاح الدولة المحددة";
    setPhoneErrorText(text);
  };

  // Get country codes based on settings and address
  getOnlyCountries = () => {
    const { settings, countries, address } = this.props;
    const countryObj = countries?.find((c) => c?.id === address?.country);

    if (
      countryObj?.name === "Nigeria" ||
      (countries?.length === 1 && countries[0].name === "Nigeria")
    )
      return ["ng"];

    if (
      settings.force_phone_code_match_country &&
      settings.enable_gcc &&
      countryObj &&
      countryObj.dial_code
    ) {
      const phoneIso = this.getIsoFromPhone(this.props.phone);

      if (this.props.phone && phoneIso && phoneIso !== countryObj.dial_code)
        this.clearPhoneNumber();
      return [countryObj.dial_code];
    }
    return settings.show_all_country_codes
      ? []
      : [
          "kw",
          "sa",
          "qa",
          "om",
          "ae",
          "bh",
          "sy",
          "lb",
          "jo",
          "eg",
          "us",
          "uk",
          "cn",
        ];
  };

  render() {
    const { language, settings, store, countries, address } = this.props;
    const inputLabelStyle = {
      transformOrigin: language === "english" ? "top left" : "top right",
      right: language === "arabic" ? 0 : "unset",
      left: language === "english" ? 0 : "unset",
    };
    const countryObj = countries?.find((c) => c?.id === address?.country);

    return (
      <div className="w-100 px-4">
        <form>
          <TextField
            error={
              (!this.props.name.trim() && this.props.nameError) ||
              this.props.nameLengthError
            }
            id="name"
            label={language === "english" ? "Name *" : "الاسم *"}
            fullWidth
            InputLabelProps={{
              style: inputLabelStyle,
              dir: language === "english" ? "ltr" : "rtl",
            }}
            InputProps={{
              dir: language === "english" ? "ltr" : "rtl",
            }}
            color="primary"
            className="my-4"
            helperText={
              this.props.nameError
                ? language === "english"
                  ? "Please enter your name"
                  : "الرجاء ادخال الاسم"
                : this.props.nameLengthError
                ? language === "arabic"
                  ? "يسمح ب 25 حرف فقط"
                  : "Name must be shorter than 16 letters"
                : ""
            }
            onChange={this.props.handleChange}
            name="name"
            autoComplete="name"
            value={this.props.name}
            FormHelperTextProps={{
              style: {
                textAlign: language === "arabic" && "right",
                marginRight: language === "arabic" && 5,
              },
            }}
          />
          {(settings.show_customer_email_field || settings.email_required) && (
            <TextField
              id="standard-basic"
              error={this.props.emailError}
              label={
                language === "english" ? (
                  <span>
                    Email {settings.email_required ? "*" : ""}{" "}
                    <span style={{ fontSize: 12 }}>(for your invoice)</span>
                  </span>
                ) : (
                  <span>
                    الايميل {settings.email_required ? "*" : ""}{" "}
                    <span style={{ fontSize: 12 }}>(لاستلام الايصال)</span>
                  </span>
                )
              }
              fullWidth
              color={this.props.highlightColor}
              onChange={this.props.handleChange}
              name="email"
              type="email"
              value={this.props.email}
              disabled={this.props.auth.user?.email}
              InputLabelProps={{
                style: inputLabelStyle,
                dir: language === "english" ? "ltr" : "rtl",
              }}
              InputProps={{
                dir: language === "english" ? "ltr" : "rtl",
              }}
              helperText={
                this.props.emailError
                  ? language === "english"
                    ? "Please enter your email"
                    : "الرجاء ادخال الايميل"
                  : ""
              }
              FormHelperTextProps={{
                style: {
                  textAlign: language === "arabic" && "right",
                  marginRight: language === "arabic" && 5,
                },
              }}
            />
          )}
          <MuiPhoneNumber
            defaultCountry={
              countryObj?.dial_code || store.default_dial_code || "kw"
            }
            disabled={
              (!!this.props.auth?.user?.phone &&
                (this.props.auth?.user?.provider === "phone" ||
                  this.props.settings.enable_aseer_time)) ||
              (this.props.settings.enable_teasers_staff &&
                this.props.settings.enable_teasers)
            }
            onlyCountries={this.getOnlyCountries()}
            excludeCountries={["il"]}
            countryCodeEditable={false}
            disableAreaCodes={true}
            error={this.props.phoneError}
            label={language === "english" ? "Phone *" : "رقم الهاتف *"}
            className="mt-4 mb-3"
            color={this.props.highlightColor}
            onChange={this.props.handleChange}
            key={this.props.phoneFieldKey}
            value={this.props.phone}
            autoComplete="tel"
            fullWidth
            helperText={
              this.props.phoneError
                ? this.props.phoneErrorText !== ""
                  ? this.props.phoneErrorText
                  : language === "english"
                  ? "Please enter your phone number"
                  : "الرجاء ادخال رقم الهاتف"
                : ""
            }
            FormHelperTextProps={{
              style: {
                textAlign: language === "arabic" && "right",
                marginRight: language === "arabic" && 5,
              },
            }}
            InputLabelProps={{
              style: inputLabelStyle,
              dir: language === "english" ? "ltr" : "rtl",
            }}
          />
          {this.props.afterPhoneContent || null}
          {this.props.settings.ask_for_civil_id && (
            <TextField
              error={!this.props.civilID.trim() && this.props.civilIDError}
              id="standard-basic"
              label={
                language === "english" ? "Civil ID *" : "رقم البطاقة المدنية *"
              }
              fullWidth
              InputLabelProps={{
                style: inputLabelStyle,
                dir: language === "english" ? "ltr" : "rtl",
              }}
              onFocus={() =>
                !this.state.civilIDFocused
                  ? this.setState({ civilIDFocused: true })
                  : {}
              }
              onBlur={() =>
                this.state.civilIDFocused
                  ? this.setState({ civilIDFocused: false })
                  : {}
              }
              className="mb-3"
              InputProps={{
                dir: language === "english" ? "ltr" : "rtl",
              }}
              color="primary"
              helperText={
                this.props.civilIDError
                  ? language === "english"
                    ? "Please enter your civil ID number"
                    : "الرجاء ادخال رقم البطاقة المدنية"
                  : ""
              }
              onChange={this.props.handleChange}
              name="civilID"
              value={this.props.civilID}
              FormHelperTextProps={{
                style: {
                  textAlign: language === "arabic" && "right",
                  marginRight: language === "arabic" && 5,
                },
              }}
            />
          )}
          {this.props.settings.collect_birthdays && (
            <DatePicker
              dateValue={this.props.dateValue}
              onChangeDate={this.props.onChangeDate}
            />
          )}
          {settings.enable_dot && (
            <div
              style={{
                marginTop: "15px",
                marginBottom: "20px",
                textAlign: language === "arabic" && "right",
                marginRight: language === "arabic" && 5,
              }}
            >
              <Checkbox
                checked={this.props.optInMarketing}
                onChange={(e) =>
                  this.props.handleChangeOptInMarketing(e.target.checked)
                }
                name="opt_in_marketing"
                checkedIcon={
                  <CheckBoxIcon style={{ color: this.props.themeColor }} />
                }
              />
              <span>
                {language === "english"
                  ? "By checking this box, you agree to receive marketing materials"
                  : "بتحديد هذا المربع ، فإنك توافق على استلام المواد التسويقية"}
              </span>
              {this.props.optInMarketing && (
                <div style={{ marginTop: "20px" }}>
                  <p>
                    {language === "english"
                      ? "I want to receive offers by:"
                      : ":أرغب في تلقي العروض عن طريق"}
                  </p>
                  <RadioGroup
                    aria-label="contact-channel"
                    name="contactChannel"
                    value={this.props.contactChannel}
                    onChange={(e) =>
                      this.props.handleChangeContactChannel(e.target.value)
                    }
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "15px",
                      justifyContent: "center",
                    }}
                  >
                    <FormControlLabel
                      value="Email"
                      control={
                        <Radio
                          checkedIcon={
                            <RadioButtonCheckedIcon
                              style={{ color: this.props.themeColor }}
                            />
                          }
                        />
                      }
                      label="Email"
                    />
                    <FormControlLabel
                      value="SMS"
                      control={
                        <Radio
                          checkedIcon={
                            <RadioButtonCheckedIcon
                              style={{ color: this.props.themeColor }}
                            />
                          }
                        />
                      }
                      label="SMS"
                    />
                  </RadioGroup>
                </div>
              )}
            </div>
          )}
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    store: state.store.store,
    auth: state.auth,
    countries: state.store.store.all_countries || state.store.store.countries,
    address: state.customers.address,
    themeColor: state.store.store.settings.dark || "#0099cc",
  };
};

export default connect(mapStateToProps)(UserForm);
